import React from 'react';
import { Box, Divider, Typography } from '@mui/material';
import { string } from 'prop-types';
import * as R from 'ramda';
import { format } from 'date-fns';

// utils
import { dateIsTodayOrInPast, formatLastUsed } from 'feature/loading-management/utils/timeHelpers';
import { useTheme } from '@mui/material/styles';
import { cardBodyDividerStyles, expirationTextStyles, lastUsedTextStyles } from './Card.styles';

const Body = ({ insuranceExpiration, lastUsed }) => {
  const theme = useTheme();
  const isExpiredDate = dateIsTodayOrInPast(insuranceExpiration);
  const formattedLastUsed = formatLastUsed(lastUsed);
  const formattedInsuranceExpiration = format(new Date(insuranceExpiration), 'M/dd/yyyy');

  const renderInsuranceExpiration = () => (
    <Box
      sx={{
        alignItems: 'center',
        bgcolor: isExpiredDate ? 'error.light' : 'graphic.lighter',
        borderRadius: 0.5,
        display: 'flex',
        flexDirection: 'column',
        height: 61,
        justifyContent: 'center',
        mb: 1,
        paddingBottom: 1,
        paddingTop: '6px',
      }}
    >
      <Typography sx={{ ...expirationTextStyles }} variant="subtitle1">
        {formattedInsuranceExpiration}
      </Typography>
      <Typography color="textSecondary" variant="body2">
        Insurance Expiration
      </Typography>
    </Box>
  );

  return (
    <>
      <Divider sx={{ ...cardBodyDividerStyles(theme) }} />
      <Typography align="center" variant="body2">
        Last Used
      </Typography>
      <Typography align="center" sx={{ ...lastUsedTextStyles(theme) }} variant="h5">
        {R.defaultTo('--', formattedLastUsed)}
      </Typography>
      {renderInsuranceExpiration()}
    </>
  );
};

Body.propTypes = {
  insuranceExpiration: string.isRequired,
  lastUsed: string,
};

Body.defaultProps = {
  lastUsed: '',
};

export default Body;
